import { render, staticRenderFns } from "./LogActivity.vue?vue&type=template&id=bec236fc&scoped=true"
import script from "./LogActivity.vue?vue&type=script&lang=js"
export * from "./LogActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec236fc",
  null
  
)

export default component.exports